import { RecurrenceEditorComponent } from "@syncfusion/ej2-react-schedule";
import { FC, useEffect, useRef, useState } from "react";
import {
  DateFieldV2,
  fieldTypes,
  PrimaryButton,
  TextField,
} from "@ucl/library";
import { GridComponent } from "@syncfusion/ej2-react-grids";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { INewBoltTask, TimeCondition } from "@bolt/core";

export interface RecurrenceEditorFieldProps
  extends fieldTypes.BaseFieldProps<TimeCondition> {
  boltTaskRuleId?: string;
  shouldDisableStartDate: boolean;
}

export const RecurrenceEditorField: FC<RecurrenceEditorFieldProps> = ({
  shouldDisableStartDate,
  boltTaskRuleId,
  value,
  onSubmit,
}) => {
  const [localValue, setLocalValue] = useState<TimeCondition>(
    value || { rule: "FREQ=WEEKLY;BYDAY=MO;INTERVAL=1;", startDate: "" }
  );
  const [evaluateOn, setEvaluateOn] = useState<string | undefined>();
  const [tasksInEvaluation, _setTasksInEvaluation] = useState<
    INewBoltTask[] | undefined
  >(undefined);
  const startDate = localValue?.startDate;
  const rule = localValue?.rule;
  const setStartDate = (updatedStartDate: string) => {
    setLocalValue({ ...localValue, startDate: updatedStartDate });
  };
  const setRule = (updatedRule: string) => {
    setLocalValue({ ...localValue, rule: updatedRule });
  };
  const recurrenceEditorComponentRef = useRef<RecurrenceEditorComponent>(null);

  useEffect(() => {
    if (onSubmit && JSON.stringify(localValue) != JSON.stringify(value)) {
      onSubmit(localValue);
    }
  }, [localValue]);

  return (
    <>
      <div className="task-rule-form-field-grey-background">
        <TooltipComponent
          content={
            "Enter the date at which this rule will be run for the first time. This date must be a date in the future."
          }
          target=".time-trigger-start-date .bp5-form-content"
          position="BottomLeft"
        >
          <div className="time-trigger-start-date">
            <DateFieldV2
              label="Start Date"
              value={startDate}
              minDate={new Date()}
              onSubmit={(startDate) => {
                setStartDate(startDate as string);
              }}
              disabled={shouldDisableStartDate}
            />
          </div>
        </TooltipComponent>
      </div>
      <div className="task-rule-form-field-grey-background">
        <div className="task-rule-form-field-flex-wrapper">
          <div className="recurrence-editor-field">
            <RecurrenceEditorComponent
              ref={recurrenceEditorComponentRef}
              id="RecurrenceEditor"
              value={rule}
              frequencies={["weekly", "monthly"]}
              change={(e) => {
                setRule(e.value);
              }}
            ></RecurrenceEditorComponent>
          </div>
        </div>
      </div>
      <div className="task-rule-form-field-grey-background">
        <TextField
          type="Text"
          fieldName="conditionsActions"
          fieldKey="conditionsActions"
          label="Then"
          value={"Create Task"}
          readOnly={true}
        />
      </div>
      {boltTaskRuleId && (
        <div className="query-builder-playground">
          <div className="query-builder-playground__time-evaluate-on">
            <DateFieldV2
              label="Evaluate On"
              value={evaluateOn}
              width="50"
              onSubmit={(date) => {
                setEvaluateOn(date);
              }}
            />
            <PrimaryButton
              text="Evaluate"
              onClick={() => {
                // Evaludate Time Base Rule
              }}
            />
          </div>
          {tasksInEvaluation && (
            <GridComponent
              dataSource={tasksInEvaluation}
              columns={[
                {
                  field: "customerName",
                  headerText: "Customer Name",
                },
                {
                  field: "accountNumber",
                  headerText: "Account Number",
                },
                {
                  field: "taskTypeName",
                  headerText: "Task Template",
                },
                {
                  field: "stepName",
                  headerText: "Step Name",
                },
              ]}
            />
          )}
        </div>
      )}
    </>
  );
};
